type FieldKeys = {
  id: string;
  name: string;
  hospitalName: string;
  search: string;
};

const fieldKeys: FieldKeys = {
  id: 'id',
  name: 'name',
  hospitalName: 'hospitalName',
  search: 'search',
};

export default fieldKeys;
